import React from "react";
import TooltipGlobal from "../live-auction/live-auction-detail/ui/tooltip/TooltipGlobal";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaArrowTrendUp } from "react-icons/fa6";

const quickBids = [100, 200, 300, 400, 500, 1000];


const QuickBidsDummy = ({ manualBid, setManualBid }) => {
  return (
    <div className="flex flex-col gap-3   justify-start h-full items-center w-[150px] lg:w-[55%] ">

      <div className="flex items-center justify-center gap-[0.425vw]">
        <h1 className="text-[12px] lg:text-15 font-medium">Quick Bid Increase:</h1>
        <TooltipGlobal
          title="Quick Bid Increase"

          description="Quickly increase your bid by selecting an amount from the list."
          placement="top"
          hoverComponent={
            <span className="cursor-pointer text-[12px] lg:text-20">
              <IoInformationCircleOutline />
            </span>
          }
        />
      </div> 

      <div className="mb-y md:my-[0.625vw] flex flex-wrap gap-2 md:gap-[0.425vw] text-[15px] font-medium">
        {quickBids.map((amount, index) => (
          <div
  key={index}
  className="w-full text-[12px] lg:text-16 flex items-center gap-1 justify-center px-2 py-1 md:px-[0.625vw] md:py-[0.417vw] bg-gray-200 text-gray-500 border border-gray-300 rounded-[0.625vw] cursor-not-allowed"
>
  <span className="">
    <FaArrowTrendUp />
  </span>
  <span className="">${amount}</span>
</div>
        ))}
      </div>
    </div>
  );
};

export default QuickBidsDummy;
